/* unplugin-vue-components disabled */import { render } from "./KnotRender.vue?vue&type=template&id=0454ffa0&scoped=true"
import script from "./KnotRender.vue?vue&type=script&lang=js"
export * from "./KnotRender.vue?vue&type=script&lang=js"

import "./KnotRender.vue?vue&type=style&index=0&id=0454ffa0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0454ffa0"]])

export default __exports__